import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "warning",
  "use": "warning-usage",
  "viewBox": "0 0 30 26",
  "content": "<symbol viewBox=\"0 0 30 26\" xmlns=\"http://www.w3.org/2000/svg\" id=\"warning\">\n<path d=\"M14.9999 5.98699L25.0399 23.3337H4.95992L14.9999 5.98699ZM14.9999 0.666992L0.333252 26.0003H29.6666L14.9999 0.666992ZM16.3333 19.3337H13.6666V22.0003H16.3333V19.3337ZM16.3333 11.3337H13.6666V16.667H16.3333V11.3337Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol